import groupItems from '../utils/groupItems';
import getItemsFromCSV from '../utils/getItemsFromCSV';

export default async () => {
    const maleNorwegianData = await getItemsFromCSV('/csv/norwegianMaleNamesAndMnemonics.csv');

    return groupItems(maleNorwegianData);
};
